import { render, staticRenderFns } from "./ykcSelect.vue?vue&type=template&id=4541b4ca&scoped=true&"
import script from "./ykcSelect.vue?vue&type=script&lang=js&"
export * from "./ykcSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541b4ca",
  null
  
)

export default component.exports